/* ================================================================ */
// STORE | index.js
/* ================================================================ */
/* ========================================== */
// Imports
/* ========================================== */
import { applyMiddleware, createStore } from 'redux';
import {createLogger} from 'redux-logger';
import thunk from 'redux-thunk';
import { createPromise } from 'redux-promise-middleware';
import createDebounce from 'redux-debounced';
import reducers from '../reducers';
/* ========================================== */
// Middleware
/* ========================================== */
let middlewareArr = [createDebounce(), createPromise(), thunk];
/*const reduxLogger = createLogger({
    level: 'console'
});*/
if(process.env.NODE_ENV !== 'production') {
    const mylogger = new createLogger({
        predicate: (getState, action) => !action.type.includes('UPDATE_MAP_VIEW_STATE')
    });

    middlewareArr = [...middlewareArr, mylogger];
}
const middleware = applyMiddleware(...middlewareArr);
/* ========================================== */
// Exports
/* ========================================== */
export function configureStore(initialState = {}) {
    const store = createStore(
        reducers,
        initialState,
        applyMiddleware(thunk)
    );
    store.asyncReducers = {};
    return store;
}
export default createStore(reducers, middleware);

/*
export function injectAsyncReducer(store, name, asyncReducer) {
    store.asyncReducers[name] = asyncReducer;
    store.replaceReducer(createReducer(store.asyncReducers));
}

/*
import { createStore } from 'redux';
import createReducer from './reducers';

export default function configureStore(initialState) {
    const store = createStore(createReducer(), initialState);
    store.asyncReducers = {};
    return store;
}

export function injectAsyncReducer(store, name, asyncReducer) {
    store.asyncReducers[name] = asyncReducer;
    store.replaceReducer(createReducer(store.asyncReducers));
}*/